var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Opend"},[_c('NotificationContent',{ref:"NotificationContent",on:{"close":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }